import React from 'react';
import './svg.css';

const NewDataIcon = () => {
  return (

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x=".3" y=".3" width="23.4" height="23.4" rx="11.7" fill="#fff" />
      <rect x=".3" y=".3" width="23.4" height="23.4" rx="11.7" stroke="#C9CCD4" strokeWidth=".6" />
      <g clipPath="url(#a)" strokeWidth=".8" strokeMiterlimit="10">
        <path d="M8.958 13.706H7.583a.515.515 0 0 1-.514-.515V9.818a.514.514 0 0 0-.514-.515h-.4a.515.515 0 0 1-.357-.886l2.57-2.478c.618-.522 1.205-.292 1.52-.032l2.544 2.51a.514.514 0 0 1-.356.886h-.403a.514.514 0 0 0-.514.514v3.373a.515.515 0 0 1-.515.515z" stroke="url(#b)" />
        <path d="M14.783 10.36h-1.348a.505.505 0 0 0-.505.505v3.313a.506.506 0 0 1-.506.505h-.394a.506.506 0 0 0-.35.87l2.523 2.432c.607.514 1.183.288 1.493.033l2.5-2.465a.505.505 0 0 0-.35-.87h-.395a.505.505 0 0 1-.505-.505v-3.819z" stroke="url(#c)" />
      </g>
      <defs>
        <radialGradient id="b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-130.578 10.808 4.613)scale(15.6187 52.5003)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient id="c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-9.9752 -11.64854 39.15461 -33.52994 20.064 20.373)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <clipPath id="a">
          <path fill="#fff" d="M4 4h16v16H4z" />
        </clipPath>
      </defs>
    </svg>
    
  )
}

export default NewDataIcon;